import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {PartnerSearchComponent} from '../partner-search/partner-search.component';
import {PartnerModel} from '../../model/partner.model';
import {NewItemModalOptions} from '../../../../../core/component/select/abstract-select.component';
import {
    PartnerSaveDialogComponent,
    PartnerSaveDialogInput,
    PartnerSaveDialogOutput
} from '../partner-save-dialog/partner-save-dialog.component';
import {PartnerSummaryModel, PartnerType} from '../../model/partnerSummary.model';

@Component({
    selector: 'app-partner-search-with-create-ability',
    templateUrl: './partner-search-with-create-ability.component.html'
})
export class PartnerSearchWithCreateAbilityComponent {

    @ViewChild('selectSearch') selectSearchComponent: PartnerSearchComponent;

    @Input() newDialogTitle = 'Créer un nouveau partenaire';
    @Input() value: PartnerSummaryModel;
    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Input() placeHolder = 'Chercher';
    @Input() noEntryPlaceHolder = 'Aucun partenaire trouvé';
    @Input() typeValue: PartnerType;
    @Input() searchTerm: string;
    @Input() automaticSelectIfOneResult = false;
    @Input() parameterSearch: string;

    @Output() changeEvent = new EventEmitter<PartnerSummaryModel>();

    get formattedNewItemModalOptions(): NewItemModalOptions<PartnerSaveDialogOutput, PartnerSaveDialogInput, PartnerSaveDialogComponent>{
        return {
            componentType: PartnerSaveDialogComponent,
            dialogInput: {
                type: this.typeValue,
            },
            dialogOption: {
                title: this.newDialogTitle,
                width: '95%'
            },
            valueNewItemMapper: (result) => {
                return result?.entity?.summary;
            }
        };
    }

    getSelectedElement(): PartnerSummaryModel {
        return this.selectSearchComponent?.getSelectedElement();
    }

    change(partner: PartnerSummaryModel) {
        if (this.changeEvent) {
            this.changeEvent.emit(partner);
        }
    }

    setValue(value: any, emitEvent = true): Promise<PartnerModel> {
        return new Promise<PartnerModel>((resolve, reject) => {
            this.selectSearchComponent?.setValue(value, emitEvent)
                .then(value1 => resolve(value1))
                .catch(reason => reject(reason));
        });

    }

    entityLoaded(entity: PartnerModel, emitEvent = true) {
        this.selectSearchComponent.entityLoaded(entity, emitEvent);
    }

}
